import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Container,
  CircularProgress,
  Alert,
  Grid,
  Paper,
  Divider,
} from '@mui/material';
import { Instagram as InstagramIcon } from '@mui/icons-material';
import api from '../../services/api';
import Messages from './Messages';
import Comments from './Comments';

const Instagram = () => {
  const [loading, setLoading] = useState(true);
  const [connected, setConnected] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    checkConnection();
  }, []);

  const checkConnection = async () => {
    try {
      setLoading(true);
      const response = await api.get('/lms/integrations/instagram/');
      setStatus(response.data);
      setConnected(Boolean(response.data?.connected));
    } catch (error) {
      console.error('Error checking Instagram connection:', error);
      setConnected(false);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Container maxWidth={false} disableGutters>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 400 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (!connected) {
    return <Navigate to="/integrations/facebook" replace />;
  }

  const accounts = status?.connectedAccounts || [];

  return (
    <Container maxWidth={false} disableGutters sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Box sx={{ px: 2, py: 1.5, borderBottom: 1, borderColor: 'divider', bgcolor: 'background.paper' }}>
        <Typography variant="body1" color="text.secondary">
          Instagram inbox — DMs and comments arrive via Meta webhooks (real-time)
        </Typography>
        {accounts.length > 0 && (
          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
            {accounts.map((a) => `@${a.instagramUsername || 'account'} (${a.pageName})`).join(' · ')}
          </Typography>
        )}
      </Box>

      <Box sx={{ flex: 1, overflow: 'auto', px: 2, py: 2 }}>
        <Grid container spacing={2.5}>
          <Grid item xs={12} lg={7}>
            <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
              <Box sx={{ px: 2, py: 1.5, display: 'flex', alignItems: 'center', gap: 1, bgcolor: 'grey.50' }}>
                <InstagramIcon sx={{ color: '#E4405F', fontSize: 20 }} />
                <Typography variant="subtitle1" fontWeight={700}>Messages</Typography>
              </Box>
              <Divider />
              <Messages connectedAccounts={accounts} outboundEnabled={status?.outboundEnabled} autoReplyEnabled={status?.autoReplyEnabled} embedded />
            </Paper>
          </Grid>
          <Grid item xs={12} lg={5}>
            <Paper variant="outlined" sx={{ borderRadius: 2, overflow: 'hidden' }}>
              <Box sx={{ px: 2, py: 1.5, display: 'flex', alignItems: 'center', gap: 1, bgcolor: 'grey.50' }}>
                <InstagramIcon sx={{ color: '#E4405F', fontSize: 20 }} />
                <Typography variant="subtitle1" fontWeight={700}>Comments</Typography>
              </Box>
              <Divider />
              <Comments connectedAccounts={accounts} outboundEnabled={status?.outboundEnabled} autoReplyEnabled={status?.autoReplyEnabled} embedded />
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};

export default Instagram;
